 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import A780802157409 from '@/components/9780802157409'
 import LOVE_1 from '@/components/love_1'
 import GROVEATLANTICLITHUB from '@/components/grove-atlantic-lithub'
 import A7808021574091 from '@/components/9780802157409-1'
 import A7808021574092 from '@/components/9780802157409-2'
 import A7808021574093 from '@/components/9780802157409-3'
 import A7808021574094 from '@/components/9780802157409-4'
 import A7808021574095 from '@/components/9780802157409-5'
 import A7808021574096 from '@/components/9780802157409-6'
 import A7808021574097 from '@/components/9780802157409-7'
 import A7808021574098 from '@/components/9780802157409-8'
 import A7808021574099 from '@/components/9780802157409-9'
 import A78080215740910 from '@/components/9780802157409-10'
 import A78080215740911 from '@/components/9780802157409-11'
 import A78080215740912 from '@/components/9780802157409-12'
 import A78080215740913 from '@/components/9780802157409-13'
 import A78080215740914 from '@/components/9780802157409-14'
 import A78080215740915 from '@/components/9780802157409-15'
 import A78080215740916 from '@/components/9780802157409-16'
 import A78080215740917 from '@/components/9780802157409-17'
 import A78080215740918 from '@/components/9780802157409-18'
 import A78080215740919 from '@/components/9780802157409-19'
 import A78080215740920 from '@/components/9780802157409-20'
 import A78080215740921 from '@/components/9780802157409-21'
 import A78080215740922 from '@/components/9780802157409-22'
 import A78080215740923 from '@/components/9780802157409-23'
 import A78080215740924 from '@/components/9780802157409-24'
 import A78080215740925 from '@/components/9780802157409-25'
 import A78080215740926 from '@/components/9780802157409-26'
 import A78080215740927 from '@/components/9780802157409-27'
 import A78080215740928 from '@/components/9780802157409-28'
 import A78080215740929 from '@/components/9780802157409-29'
 import A78080215740930 from '@/components/9780802157409-30'
 import A78080215740931 from '@/components/9780802157409-31'
 import A78080215740932 from '@/components/9780802157409-32'
 import A78080215740933 from '@/components/9780802157409-33'
 import A78080215740934 from '@/components/9780802157409-34'
 import A78080215740935 from '@/components/9780802157409-35'
 import A78080215740936 from '@/components/9780802157409-36'
 import A78080215740937 from '@/components/9780802157409-37'
 import A78080215740938 from '@/components/9780802157409-38'
 import A78080215740939 from '@/components/9780802157409-39'
 import A78080215740940 from '@/components/9780802157409-40'
 import A78080215740941 from '@/components/9780802157409-41'
 import A78080215740942 from '@/components/9780802157409-42'
 import A78080215740943 from '@/components/9780802157409-43'
 import A78080215740944 from '@/components/9780802157409-44'
 import A78080215740945 from '@/components/9780802157409-45'
 import A78080215740946 from '@/components/9780802157409-46'
 import A78080215740947 from '@/components/9780802157409-47'
 import A78080215740948 from '@/components/9780802157409-48'
 import A78080215740949 from '@/components/9780802157409-49'
 import A78080215740950 from '@/components/9780802157409-50'
 import A78080215740951 from '@/components/9780802157409-51'
 import A78080215740952 from '@/components/9780802157409-52'
 import A78080215740953 from '@/components/9780802157409-53'
 import A78080215740954 from '@/components/9780802157409-54'
 import A78080215740955 from '@/components/9780802157409-55'
 import A78080215740956 from '@/components/9780802157409-56'
 import A78080215740957 from '@/components/9780802157409-57'
 import A78080215740958 from '@/components/9780802157409-58'
 import A78080215740959 from '@/components/9780802157409-59'
 import A78080215740960 from '@/components/9780802157409-60'
 import A78080215740961 from '@/components/9780802157409-61'
 import A78080215740962 from '@/components/9780802157409-62'
 import A78080215740963 from '@/components/9780802157409-63'
 import A78080215740964 from '@/components/9780802157409-64'
 import A78080215740965 from '@/components/9780802157409-65'
 import A78080215740966 from '@/components/9780802157409-66'
 import A78080215740967 from '@/components/9780802157409-67'
 import A78080215740968 from '@/components/9780802157409-68'
 import A78080215740969 from '@/components/9780802157409-69'
 import A78080215740970 from '@/components/9780802157409-70'
 import A78080215740971 from '@/components/9780802157409-71'
 import A78080215740972 from '@/components/9780802157409-72'
 import A78080215740973 from '@/components/9780802157409-73'
 import A78080215740974 from '@/components/9780802157409-74'
 import A78080215740975 from '@/components/9780802157409-75'
 import A78080215740976 from '@/components/9780802157409-76'
 import A78080215740977 from '@/components/9780802157409-77'
 import A78080215740978 from '@/components/9780802157409-78'
 import A78080215740979 from '@/components/9780802157409-79'
 import A78080215740980 from '@/components/9780802157409-80'
 import A78080215740981 from '@/components/9780802157409-81'
 import A78080215740982 from '@/components/9780802157409-82'
 import A78080215740983 from '@/components/9780802157409-83'
 import A78080215740984 from '@/components/9780802157409-84'
 import A78080215740985 from '@/components/9780802157409-85'
 import A78080215740986 from '@/components/9780802157409-86'
 import A78080215740987 from '@/components/9780802157409-87'
 import A78080215740988 from '@/components/9780802157409-88'
 import A78080215740989 from '@/components/9780802157409-89'
 import A78080215740990 from '@/components/9780802157409-90'
 import A78080215740991 from '@/components/9780802157409-91'
 import A78080215740992 from '@/components/9780802157409-92'
 import A78080215740993 from '@/components/9780802157409-93'
 import A78080215740994 from '@/components/9780802157409-94'
 import A78080215740995 from '@/components/9780802157409-95'
 import A78080215740996 from '@/components/9780802157409-96'
 import A78080215740997 from '@/components/9780802157409-97'
 import A78080215740998 from '@/components/9780802157409-98'
 import A78080215740999 from '@/components/9780802157409-99'
 import LOVE_2 from '@/components/love_2'
 import A780802157409100 from '@/components/9780802157409-100'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/9780802157409",
 			"name" : "9780802157409",
 			"component" : A780802157409
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/grove-atlantic-lithub",
 			"name" : "grove-atlantic-lithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/9780802157409-1",
 			"name" : "9780802157409-1",
 			"component" : A7808021574091
 		},
 		{
 			"path" : "/9780802157409-2",
 			"name" : "9780802157409-2",
 			"component" : A7808021574092
 		},
 		{
 			"path" : "/9780802157409-3",
 			"name" : "9780802157409-3",
 			"component" : A7808021574093
 		},
 		{
 			"path" : "/9780802157409-4",
 			"name" : "9780802157409-4",
 			"component" : A7808021574094
 		},
 		{
 			"path" : "/9780802157409-5",
 			"name" : "9780802157409-5",
 			"component" : A7808021574095
 		},
 		{
 			"path" : "/9780802157409-6",
 			"name" : "9780802157409-6",
 			"component" : A7808021574096
 		},
 		{
 			"path" : "/9780802157409-7",
 			"name" : "9780802157409-7",
 			"component" : A7808021574097
 		},
 		{
 			"path" : "/9780802157409-8",
 			"name" : "9780802157409-8",
 			"component" : A7808021574098
 		},
 		{
 			"path" : "/9780802157409-9",
 			"name" : "9780802157409-9",
 			"component" : A7808021574099
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js